'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userConstants = require('../../common/users/userConstants');

Object.keys(_userConstants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _userConstants[key];
    }
  });
});
var TRACK_USERS = exports.TRACK_USERS = 'TRACK_USERS';
var USERS_LOAD = exports.USERS_LOAD = 'USERS_LOAD';
var USER_ACTIVITY_LOAD = exports.USER_ACTIVITY_LOAD = 'USER_ACTIVITY_LOAD';
var USER_ACTIVITY_ERROR = exports.USER_ACTIVITY_ERROR = 'USER_ACTIVITY_ERROR';


//////////////////
// WEBPACK FOOTER
// ./src/client/user/userConstants.js
// module id = 311
// module chunks = 0